import React from "react";
import { LayoutProps } from "../../types";
import Sidebar from "../sidebar/sidebar";
import Navbar from "../navbar/navbar";
import { useSelector } from "react-redux";
import { selectSidebarExpanded } from "../../store/sidebarSlice";
import { useAppState } from "../../hooks/useAppState";

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const isExpanded = useSelector(selectSidebarExpanded);
  const { user } = useAppState();
  return (
    <div className=" bg-gray-50">
      <Sidebar />
      <div
        className={`transition-all bg-custom-gradient h-full   duration-300 ${
          isExpanded ? "ml-52" : "ml-9"
        } `}
        style={{
          background:
            user?.role === "supporty_admin"
              ? "linear-gradient(180deg, #FFFFFF 0%, #F15D18 403.08%)"
              : "linear-gradient(180deg, #FFFFFF 0%, #F15D18 403.08%)",
        }}
      >
        <Navbar />
        <main className="px-6 pt-12  mt-10 ml-5 pb-6">
          <div className=" mx-auto h-full  ">
            <div className="bg-white rounded-lg shadow-sm">{children}</div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default Layout;
